/* useIsCustomCohortActive.ts */

/* React-Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/**
 * True when a custom cohort is currently applied for the active disease.
 *
 * A custom cohort carves out a sub-population by feature filters, so the
 * three-way completeness states ("has value" / "looked for, no value" / "not
 * looked for") have no well-defined denominator against it - the group was
 * selected on the basis of having/using values in the first place. The
 * "show no-value entries" toggle is therefore disabled, and treated as off,
 * whenever this is true.
 *
 * Mirrors the exact condition that makes the fetch send `customCohortsStr`
 * (see `useFetchWithMainCondition`): a per-disease `customCohortsStr` is
 * present only when at least one custom cohort is currently shown.
 */
export const useIsCustomCohortActive = (): boolean => {
  const mainConditionValue = useSelector(
    (state: RootState) =>
      state.insightsFilter.mainCondition?.value
  );
  const customCohortsByDisease = useSelector(
    (state: RootState) =>
      state.customCohorts.customCohortsByDisease
  );

  if (!mainConditionValue) return false;

  return Boolean(
    customCohortsByDisease[mainConditionValue]
      ?.customCohortsStr
  );
};
